import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { actions as productCatalogActions } from '../../../../store/ducks/product-catalog.duck';
import { IAppState } from '../../../../store/rootDuck';
import { useManufacturerSearch } from './useManufacturesSearch';
import { usePricesFilter } from './usePricesFilter';

export function useCatalogSearch() {
  const dispatch = useDispatch();
  const { categoryIdActive } = useSelector((store: IAppState) => ({
    categoryIdActive: store.productsCatalog.categoryIdActive,
  }));
  const { manufacturer, load } = useManufacturerSearch({ initCheck: true });
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get('category');
  const { priceFromNumber, priceToNumber, urlPrices } = usePricesFilter();

  useEffect(() => {
    if (category) {
      dispatch(productCatalogActions.setCategoryIdActive(Number(category)));
    }
  }, []);

  useEffect(() => {
    if (categoryIdActive) {
      setSearchParams(searchParams => {
        searchParams.set('category', String(categoryIdActive));
        return searchParams;
      });
    } else {
      setSearchParams(searchParams => {
        searchParams.delete('category');
        return searchParams;
      });
    }
  }, [categoryIdActive]);

  const setCategory = (id: number) => {
    setSearchParams(searchParams => {
      searchParams.set('category', String(id));
      return searchParams;
    });
  };

  return {
    category: category ? Number(category) : null,
    setCategory,
    manufacturer,
    load,
    priceFrom: priceFromNumber,
    priceTo: priceToNumber,
    urlPrices
  };
}
